import React, {Component} from 'react'
import 'antd/lib/date-picker/style/index.css'
import PropTypes from 'prop-types'
import {DatePicker} from 'antd'
import moment from 'moment'

const {RangePicker} = DatePicker

class FilterDatePacking extends Component {
    timeout = 0

    _handleDateChange = async (date, dateString) => {
        const [from, to] = dateString
        const {onChangeDate, onSubmit, fieldTo, fieldFrom} = this.props

        if (this.timeout) {
            clearTimeout(this.timeout)
        }

        if (typeof onChangeDate === 'function' && typeof onSubmit === 'function') {
            const filter = Object.assign({}, this.props.filter)
            filter[fieldFrom] = from
            filter[fieldTo] = to

            if (to === undefined && from === undefined) {
                delete filter[fieldFrom]
                delete filter[fieldTo]
            }

            await onChangeDate(filter)
            this.timeout = setTimeout(() => {
                onSubmit()
            }, 1000)
        }
    }

    render() {
        const {label} = this.props

        return (
            <div className="FilterDatePacking mr-3 mb-2 d-flex flex-column">
                <label htmlFor="" className='mb-0 font-weight-bold'>{label}</label>
                <RangePicker
                style={{minWidth: 300}}
                    placeholder={['Ngày bắt đầu', 'Ngày kết thúc']}
                    ranges={{
                        'Today': [moment(), moment()],
                        'Last 7 Days': [moment().subtract(6, 'day'), moment()],
                        'This Month': [moment().startOf('month'), moment().endOf('month')],
                    }}
                    format={'DD/MM/YYYY'}
                    onChange={this._handleDateChange}
                />
            </div>
        )
    }
}

FilterDatePacking.propTypes = {
    filter: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
}

export default FilterDatePacking